import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { MyOrderFragment } from '../../../generated/graphql';
import BookingTile from '../../BookingTile';
import Title from '@oberoninternal/travelbase-ds/components/primitive/Title';
import { bookingRequiresPayment, isBookingType } from '../../../utils/myOrder';
import SectionTitleWrapper from './SectionTitleWrapper';
import EmptyState from './EmptyState';
import Anchor from '../../designsystem/Anchor';
import Link from 'next/link';

interface Props {
    orders: MyOrderFragment[];
}

const BookingHistory: FC<React.PropsWithChildren<Props>> = ({ orders }) => {
    const sortedOrders = orders
        .map(order => order)
        .sort((a, b) =>
            bookingRequiresPayment(a) && !bookingRequiresPayment(b)
                ? -1
                : bookingRequiresPayment(b) && !bookingRequiresPayment(a)
                ? 1
                : 0
        );

    if (orders.length === 0) {
        return (
            <EmptyState
                title={<FormattedMessage defaultMessage="Je hebt momenteel nog geen boekingsgeschiedenis." />}
                description={
                    <FormattedMessage
                        defaultMessage="Boek nu je eerste <activityLink>activiteit</activityLink> of <accoLink>accommodatie</accoLink>."
                        values={{
                            activityLink: children => (
                                <Link href="/agenda" legacyBehavior>
                                    <Anchor>{children}</Anchor>
                                </Link>
                            ),
                            accoLink: children => (
                                <Link href="/search" legacyBehavior>
                                    <Anchor>{children}</Anchor>
                                </Link>
                            ),
                        }}
                    />
                }
            />
        );
    }

    return (
        <>
            <SectionTitleWrapper>
                <Title elementType="h3">
                    <FormattedMessage defaultMessage="Boekingsgeschiedenis" />
                </Title>
            </SectionTitleWrapper>
            {sortedOrders.map((order, i) => (
                <BookingTile
                    key={i}
                    orderNumber={order.number ?? undefined}
                    requiresPayment={bookingRequiresPayment(order)}
                    numBookings={order.orderItems.filter(isBookingType('Booking')).length}
                    numTickets={order.orderItems.filter(isBookingType('Ticket')).length}
                    createdDate={order.createdDate!}
                    orderId={order.id!}
                    orderItems={order.orderItems}
                />
            ))}
        </>
    );
};

export default BookingHistory;
